<template lang="html">
  <div id="header" class="parallaxbg">
    <div class="section-overly">
      <div class="outer-text">
        <div class="middle-text">
          <div class="inner-text">
            <div class="modal-wrap login-page">
              <div class="modal-bodies">
                <div class="downtime-banner modal-body text-bold" v-if="showDownTimeWarning">
                  {{showDownTimeMessage }} <a :href="'mailto:'+showDownTimeSubMessage">{{ showDownTimeSubMessage }}</a>
                </div>
                <div class="row modal-body">
                  <div class="col-lg-5 col-md-6 col-sm-6 col-xs-12 no-padding">
                    <div class="login-wrap">
                      <div class="login-header">
                        <span class="logo-left">
                          <img :src="getClientLogo()" class="img-responsive" alt="" />
                        </span>
                        <span class="logo-right d-flex align-items-center" :class="getClientLogo() ? 'ml-auto' : ''">
                          <span class="mr-10">
                            <b>Powered by </b>
                          </span>
                          <img :src="Logo" class="img-responsive" alt="" />
                        </span>
                      </div>
                      <div v-if="showOTPForm">
                        <div class="login-form">
                          <form @submit.prevent>
                            <div v-if="remainingOtpAttempts !== null && remainingOtpAttempts > 0"
                              class="login-error text-left mb-15">
                              <div class="login-error-body mb-15">
                                <p class="d-inline-default">{{ $t('REMAINING_ATTEMPTS') }} : </p>
                                <span>{{ remainingOtpAttempts || 0 }}</span>
                              </div>
                            </div>
                            <h3 class="inputtitle">Two-factor Authentication</h3>
                            <div class="input-group">
                              <input type="number" required v-model="otpInput">
                              <label>Enter OTP</label>
                            </div>
                            <p v-if="showTimer">Time left: {{ formattedTimer }} </p>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding footer-section">
                              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding dspl_inline" v-if="!timer">
                                <div class="forgot-pswd" @click="resend">
                                  <h4>Resend OTP</h4>
                                </div>
                              </div>
                              <div v-if="!disableOtpSubmission"
                                class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding spl_inlineblock floatright">
                                <div class="button-style">
                                  <button type="button" @click="submit" class="primary-btn login-btn">
                                    Submit
                                  </button>
                                </div>
                              </div>
                              <div v-else-if="remainingOtpAttempts <= 0" class="login-error text-left mb-15">
                                <div class="login-error-body mb-15">
                                  <span>For your security, your account has been locked due to multiple invalid OTP
                                    attempts. Please contact your Business Admin to unlock your account</span>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                      <div :class="['login-form', { 'pt-10': remainingAttempts !== -1 }]"
                        v-if="viewLogin && !showOTPForm">
                        <div v-if="showPandoLogin && !isPandoLogin">
                          <div class="col-lg-6
                              col-md-6
                              col-sm-6
                              col-xs-12
                              no-padding">
                            <div class="button-style">
                              <button type="button" @click="pandoLogin" class="primary-btn login-btn">
                                Pando Log in
                              </button>
                            </div>
                          </div>
                        </div>
                        <form @submit.prevent="login">
                          <div v-if="remainingAttempts >= 1" class="login-error text-left mb-15">
                            <span class="login-error-header" v-if="error">{{ $t('EMAIL_OR_PASSWORD_INCORRECT') }}</span>
                            <span class="login-error-header" v-if="error_password">{{ $t('PASSWORD_INCORRECT') }}</span>
                            <div class="login-error-body">
                              <p class="d-inline-default">{{ $t('REMAINING_ATTEMPTS') }} : </p>
                              <span>{{ remainingAttempts }}</span>
                              <p><span class="fw-600">{{ $t('LOGIN_WARNING') }} : </span>{{ $t('AFTER') }} <span
                                  class="fw-600">{{ consecutiveErrorCounter }} {{ $t('CONSECUTIVE') }}</span>
                                {{ $t('UNSUCCESSFUL_LOGIN_WARNING_TEXT') }}</p>
                            </div>
                          </div>
                          <div v-if="remainingAttempts === 0 && !accountLocked" class="login-error text-left mb-15">
                            <span class="login-error-header">{{ $t('ACCOUNT_HAS_BEEN_LOCKED') }}</span>
                            <p class="login-error-optional">{{ $t('TOO_MANY_FAILED_ATTEMPTS_MSG') }}</p>
                          </div>
                          <div v-if="accountLocked" class="login-error text-left mb-15">
                            <span class="login-error-header">{{ $t('ACCOUNT_LOCKED') }}</span>
                            <p class="login-error-optional">{{ $t('ACCOUNT_LOCKED_SUB_TEXT') }}</p>
                          </div>
                          <span class="error" v-if="(error || error_password) && remainingAttempts === -1">Invalid
                            Credentials</span>
                          <div class="input-group">
                            <input type="text" required v-model="email" v-on:keyup.13="login" autocomplete="off" />
                            <label>User name:</label>
                          </div>
                          <div class="input-group" style="display: inherit;">
                            <input type="password" required id="password" name="password" autocomplete="off"
                              readonly="true" onfocus="this.removeAttribute('readonly')">
                            <i class="el-input__icon" slot="suffix" @click="showHide()">
                              <svgicon :name="icon" width="14" height="14" />
                            </i>
                            </input>
                            <label>Password:</label>
                          </div>
                          <div class="captcha-wrapper"
                            v-if="enableCaptcha && (!validCaptcha && siteKey) && remainingAttempts !== 0">
                            <div class="captcha-vertical-center">
                              <h2 class="sub-head mt-0"> Verify Captcha </h2>
                              <vue-recaptcha ref="recaptcha" @verify="onCaptchaVerified" @expired="onCaptchaExpired"
                                :loadRecaptchaScript="true" :sitekey="`${siteKey}`" />
                            </div>
                          </div>
                          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding footer-section text-left"
                            v-if="(!enableCaptcha || (enableCaptcha && validCaptcha)) && !accountLocked">
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding dspl_inline">
                              <div class="forgot-pswd" @click="viewForgotPassword()">
                                <h4 style="color: #003D31;">Forgot password?</h4>
                              </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding dspl_inlineblock floatright">
                              <div class="button-style">
                                <button type="submit" class="primary-btn login-btn">
                                  Log in
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div class="login-form reset" v-else-if="resetPasswordResponse">
                        <h3 class="inputtitle text-md">CHECK EMAIL FOR TEMPORARY PASSWORD</h3>
                        <div class="login-info">
                          A message has been sent to you by email with instructions on how to reset your password.
                        </div>
                        <div class="col-lg-6
                            col-md-6
                            col-sm-6
                            col-xs-12
                            no-padding">
                          <div class="button-style f-left">
                            <button type="button" @click="viewLoginScreen" class="primary-btn login-btn">
                              LOGIN
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="login-form" v-else-if="!showOTPForm">
                        <form>
                          <h3 class="inputtitle">FORGOT PASSWORD</h3>
                          <div class="input-group">
                            <input type="text" required v-model="email" v-on:keyup.13="resetPassword">
                            <label>Enter registered email address:</label>
                          </div>
                          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding footer-section">
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding dspl_inline">
                              <div class="forgot-pswd" @click="viewLoginScreen()">
                                <h4 style="color: #003D31;">Back to login</h4>
                              </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding spl_inlineblock floatright">
                              <div class="button-style">
                                <button type="button" @click="resetPassword" class="primary-btn login-btn">
                                  Reset password
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="login-disclaimer">
                        {{ $t('PANDO_PRIVACY_POLICY') }}
                        <h4 class="mb-0" @click="viewPrivacyPolicy()">
                          Pando Privacy Policy
                        </h4>
                      </div>
                      <!-- <div class="conditions">
                        <h5>Warning!</h5>
                        <p>Pando does not require
                          installation of any additional software.
                          Be advised to protect from malware
                          pretending Trusteer Rapport.</p>
                      </div> -->
                    </div>
                  </div>
                  <div class="col-lg-7 col-md-6 col-sm-6 col-xs-12 no-padding">
                    <div class="radius-right" style="height: 100%;">
                      <img src="@common/asset/images/Sign_In.jpg" class="img-responsive" alt=""
                        style="border-radius:0 14px 14px 0px; height: 100%;" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script >
window.redirectToNewPage = () => {
  window.oauthWindow.close();
  window.location.replace('/indents');
}
import { mapGetters } from 'vuex';
import firebase from 'firebase';
import Login from '@/components/mixins/Login';
import Logo from '@common/asset/images/logo.svg';
import GenericLogo from '@common/asset/images/generic_logo.svg';
import Bg from '@common/asset/images/Sign_In.jpg';
import { required, email } from 'vuelidate/lib/validators';
import setLocale from '@/utils/localisation';
import VueRecaptcha from 'vue-recaptcha';
const CryptoJS = require('crypto-js');


export default {
  mixins: [Login],
  components: {
    VueRecaptcha,
  },
  data() {
    return {
      email: null,
      Logo,
      GenericLogo,
      Bg,
      error: false,
      error_password: false,
      viewLogin: true,
      resetPasswordResponse: null,
      icon: 'icon-eye-view',
      remainingAttempts: -1,
      consecutiveErrorCounter: 0,
      attempts: 0,
      validCaptcha: false,
      showTimer: false,
      timer: 0,
      timeLeft: 0,
      endTime: 0,
      showOTPForm: false,
      otpInput: '',
      showPandoLogin: false,
      remainingOtpAttempts: null,
      disableOtpSubmission: false,
      accountLocked: false,
    };
  },

  validations: {
    email: {
      required,
      email,
    },
  },

  computed: {
    ...mapGetters({
      environmentVariables: 'app/environmentVariables',
      logoInfo: 'app/getLogo',
      isPaymentError: 'app/getIsPaymentError',
    }),
    showDownTimeWarning() {
      const isEnabled = (this.environmentVariables.is_warning_message === 'true' || this.environmentVariables.is_warning_message === true) || false;
      return !['pgsa.pando.in', 'development23.pandostaging.in'].includes(window.location.hostname) && isEnabled;
    },
    showDownTimeMessage() {
      return (this.environmentVariables && this.environmentVariables.show_message) || '';
    },
    showDownTimeSubMessage() {
      return (this.environmentVariables && this.environmentVariables.mail_to) || '';
    },
    enableCaptcha() {
      return (this.environmentVariables.rc_enabled === 'true' || this.environmentVariables.rc_enabled === true) && this.attempts >= 3;
    },
    siteKey() {
      return this.environmentVariables.rc_site_key;
    },
    formattedTimer() {
      if (this.timeLeft >= 0) {
        const minutes = Math.floor((this.timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((this.timeLeft % (1000 * 60)) / 1000);
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
      }
    },
    isPandoLogin() {
      const pandoLogin = this.$route.query.pandoLogin;
      return this.showPandoLogin && pandoLogin;
    },
  },

  async created() {
    if (this.isPaymentError) {
      this.$errorMessage({ message: 'Payment Required.' });
    }
    const key = `${window.location.host}-attempts`;
    this.attempts = JSON.parse(localStorage.getItem(key)) || 0;
    const ssoCheck = await this.$store.dispatch('app/ssoCheck');
    this.showPandoLogin = ssoCheck.data.showPandoLogin;
    // if (ssoCheck.status !== 404) {
    //   this.$router.push({ name: 'AzureLogin' });
    // }
  },
  methods: {
    pandoLogin() {
      window.oauthWindow = window.open('/login?pandoLogin=true',
        'Pando Login', 'width=800,height=600');
    },
    getClientLogo() {
      return this.logoInfo ? this.logoInfo
        : GenericLogo;
    },
    showHide() {
      const x = document.getElementById('password');
      if (x.type === 'password') {
        x.type = 'text';
        this.icon = 'icon-eye-hide';
      } else {
        x.type = 'password';
        this.icon = 'icon-eye-view';
      }
    },
    updateLoginAttempts(key) {
      const storedAttempts = JSON.parse(localStorage.getItem(key));
      this.validCaptcha = false;
      if (storedAttempts) {
        localStorage.setItem(key, (parseInt(storedAttempts, 10) + 1).toString());
        this.attempts = (parseInt(storedAttempts, 10) + 1);
      } else {
        localStorage.setItem(key, 1);
        this.attempts = 1;
      }
    },
    startTimer() {
      const time = new Date().getTime();
      const newTime = Math.ceil(time / 1000) * 1000;
      this.endTime = newTime + (this.timer * 1000);
      const startTime = new Date().getTime();
      this.timeLeft = this.endTime - startTime;

      this.timerTimeout = setInterval(() => {
        if (this.timeLeft > 0) {
          const currentTime = new Date().getTime();
          this.timeLeft = this.endTime - currentTime;
        } else {
          clearInterval(this.timerTimeout);
          this.endTime = 0;
          this.showTimer = false;
          this.timeLeft = 0;
          this.timer = 0;
          this.timerId = setTimeout(() => {
            this.showOTPForm = false;
            this.otpInput = '';
          }, 30000);
        }
      }, 1000);
    },
    async redirect(key) {
      this.attempts = 0;
      localStorage.setItem(key, JSON.stringify(0));
      const loginResult = await this.$store.dispatch('app/bootstrap', true);
      if (loginResult && loginResult.current_user && this.environmentVariables.rtly_site_key) {
        const vueContainer = document.getElementById('retently-survey-embed');
        if (vueContainer) {
          vueContainer.setAttribute(
            'data-href',
            `https://app.retently.com/api/remote/tracking/${this.environmentVariables.rtly_site_key}`,
          );
          vueContainer.setAttribute('data-rel', 'dialog');
          vueContainer.setAttribute('data-campaign', 'regular');
          vueContainer.setAttribute('data-email', loginResult.current_user.email || '-');
          vueContainer.setAttribute('data-firstname', loginResult.current_user.name || '-');
          vueContainer.setAttribute('data-lastname', '-');
          vueContainer.setAttribute('data-company', loginResult.client.name || '-');
          vueContainer.setAttribute('data-tags', 'inapp');
          const script = document.createElement('script');
          script.innerHTML = (function (d, s, id) {
            let js,
              rjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);
            js.id = id;
            js.src =
              'https://cdn.retently.com/public/components/embed/sdk.min.js';
            rjs.parentNode.insertBefore(js, rjs);
          }(document, 'script', 'retently-jssdk'));
          document.head.appendChild(script);
        }
      }
      if (loginResult && loginResult.current_user) {
        // Generating FCM token for User
        try {
          await firebase
            .messaging()
            .requestPermission()
            .then(() => firebase.default.messaging().getToken()
              .then((token) => {
                this.$store.dispatch('app/fcmToken', token);
              })
              .catch((err) => {
                console.log('error while generating token', err);
              }))
            .catch((err) => {
              console.log('Notification permission not granted', err);
            });
        } catch (error) {
          console.log('Firebase error');
        }
      }
      const language = (loginResult && loginResult.configurations &&
        loginResult.configurations.locales && loginResult.configurations.locales.default_locale) ?
        loginResult.configurations.locales.default_locale : 'en';
      this.setFreshWidget(loginResult);
      this.validateRedirect(loginResult);
      await setLocale(language);
      this.$store.commit('app/BOOTSTRAP_LOADING', false);
    },
    async submit() {
      const optAuth = localStorage.getItem('otp-auth-token');
      const data = { otp: this.otpInput, secretKey: optAuth };
      const result = await this.$store.dispatch('app/verifyToken', {
        data,
      });
      localStorage.setItem('otp-verified', false);
      if (result.status === 204) {
        const key = `${window.location.host}-attempts`;
        localStorage.setItem('otp-verified', true);
        clearInterval(this.timerTimeout);
        if (this.$route.query.pandoLogin) {
          window.opener.redirectToNewPage();
        }
        await this.redirect(key);
      } else if (result.data && result.data.remainingAttempts > 0) {
        this.remainingOtpAttempts = result.data.remainingAttempts;
        this.$errorMessage({ message: 'Invalid OTP' });
      } else if (result.data && result.data.remainingAttempts <= 0) {
        this.$errorMessage({ message: 'Invalid OTP' });
        this.remainingOtpAttempts = result.data.remainingAttempts;
        this.disableOtpSubmission = true;
      } else {
        this.$errorMessage({ message: 'Invalid OTP' });
      }
    },
    async resend() {
      localStorage.setItem('otp-auth-token', '');
      const data = { email: this.email };
      const result = await this.$store.dispatch('app/generateToken', {
        data,
      });
      if (result.otpAuthToken) {
        clearTimeout(this.timerId);
        this.showTimer = true;
        this.timer = result.otp_timer || 0;
        this.showOTPForm = true;
        localStorage.setItem('otp-auth-token', result.otpAuthToken);
        this.startTimer();
      }
    },
    async login() {
      this.$v.email.$touch();
      if (!this.$v.email.$error) {
        try {
          const appConfidentialKey = window.location.origin.replace(/\/|http:|https:/gi, () => '');
          const encryptedPassword = CryptoJS.AES.encrypt(JSON.stringify(document.getElementById('password').value), appConfidentialKey).toString();
          const encryptedEmail = CryptoJS.AES.encrypt(JSON.stringify(this.email), appConfidentialKey).toString();
          const payload = { email: encryptedEmail, password: encryptedPassword };
          const encryptedPayload = CryptoJS.AES.encrypt(JSON.stringify(payload), `${appConfidentialKey}/pandoV3`).toString();

          const tableParameters = localStorage.getItem('tableParameters');
          // localStorage.clear();
          if (tableParameters) {
            localStorage.setItem('tableParameters', tableParameters);
          }
          const result = await this.$store.dispatch('app/loginV3', { data: encryptedPayload });
          const key = `${window.location.host}-attempts`;
          if (result && result.otpAuthToken) {
            this.attempts = 0;
            this.showTimer = true;
            this.timer = result.otp_timer || 0;
            localStorage.setItem(key, JSON.stringify(0));
            this.showOTPForm = true;
            localStorage.setItem('otp-verified', false);
            localStorage.setItem('otp-auth-token', result.otpAuthToken);
            this.startTimer();
          }
          if (result) {
            if (result.status === 204 && result.headers && result.headers['x-auth-token']) {
              this.attempts = 0;
              if (this.$route.query.pandoLogin) {
                window.opener.redirectToNewPage();
              }
              localStorage.setItem(key, JSON.stringify(0));
              if (this.$route.query.serviceUrl) {
                await this.$store.dispatch('app/bootstrap');
                this.validateServiceUrl(this.$route.query.serviceUrl);
              } else {
                await this.redirect(key);
              }
            } else if (result.status === 404) {
              this.updateLoginAttempts(key);
              this.error_password = false;
              this.error = true;
              this.remainingAttempts = (result.data && result.data.remainingAttempts) || -1;
              if (!this.consecutiveErrorCounter) {
                this.consecutiveErrorCounter = this.remainingAttempts;
              } else {
                this.consecutiveErrorCounter -= 1;
              }
            } else if (result.status === 401) {
              this.updateLoginAttempts(key);
              this.error = false;
              this.error_password = true;
            } else if (result.status === 402) {
              this.error = false;
              this.error_password = true;
              this.$errorMessage({ message: 'Payment Required' });
            } else if (result.data && result.data.errors) {
              if (result.data.errors[0]) {
                if (
                  result.data.errors[0].message === 'ERR_TEMP_PASSWORD_EXPIRED'
                ) {
                  this.$errorMessage({
                    message:
                      'This temporary password is no longer valid. Please click Forgot Password? to receive a new temporary password.',
                  });
                } else if (result.data.errors[0].code === 'ERR_MAX_LOGIN_ATTEMPTS') {
                  this.remainingAttempts = 0;
                } else if(result.data.errors[0].code === 'ERR_LOGIN_ATTEMPT_LOCKED') {
                  this.remainingAttempts = 0;
                  this.accountLocked = true
                } else if (
                  result.data.errors[0].code === 'ERR_LOGIN_INACTIVATED'
                ) {
                  this.$errorMessage({
                    message: result.data.errors[0].message,
                  });
                } else if (
                  result.data.errors[0].code === 'ERR_DOMAIN_ERROR'
                ) {
                  this.$errorMessage({
                    message: result.data.errors[0].message,
                  });
                } else {
                  this.$errorMessage({
                    message: result.data.errors[0].message,
                  });
                }
              }
            }
          }
        } catch (err) {
          return err;
        }
      } else {
        this.error = true;
        this.error_password = false;
      }
      return true;
    },
    validateServiceUrl(serviceUrl) {
      if (serviceUrl.includes('-ct')) {
        this.$router.push({
          name: 'ControlTower',
          query: { serviceUrl: this.$route.query.serviceUrl },
        });
      } else if (serviceUrl.includes('-pack')) {
        this.$router.push({
          name: 'Pack',
          query: { serviceUrl: this.$route.query.serviceUrl },
        });
      } else if (serviceUrl.includes('-fap')) {
        this.$router.push({
          name: 'Fap',
          query: { serviceUrl: this.$route.query.serviceUrl },
        });
      } else if (serviceUrl.includes('-ohub')) {
        this.$router.push({
          name: 'OrderHub',
          query: { serviceUrl: this.$route.query.serviceUrl },
        });
      } else if (serviceUrl.includes('-ohub')) {
        this.$router.push({
          name: 'localhost',
          query: { serviceUrl: this.$route.query.serviceUrl },
        });
      }
    },
    async resetPassword() {
      try {
        const data = { email: this.email };
        const result = await this.$store.dispatch('app/forgotPassword', {
          data,
        });
        if (result.status === 204) {
          this.resetPasswordResponse = true;
        } else if (result.status === 404) {
          this.$errorMessage({
            message: 'No account is found with the given email address',
          });
        } else if (result && result.data && result.data.errors) {
          this.$errorMessage({ message: result.data.errors[0].message });
        }
      } catch (err) {
        this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    viewLoginScreen() {
      this.viewLogin = true;
      this.resetPasswordResponse = null;
    },
    viewForgotPassword() {
      this.viewLogin = false;
      this.resetPasswordResponse = null;
    },
    viewPrivacyPolicy() {
      window.open('https://pando.ai/privacy.php', '_blank');
    },
    async onCaptchaVerified(recaptchaToken) {
      try {
        const response = await this.$store.dispatch('app/reCaptchaVerify', recaptchaToken);
        if (response && response.data && response.data.success) {
          this.validCaptcha = true;
        } else {
          this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
        }
      } catch (error) {
        throw error;
      }
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
    updateLoginAttempts(key) {
      const storedAttempts = JSON.parse(localStorage.getItem(key));
      this.validCaptcha = false;
      if (storedAttempts) {
        localStorage.setItem(key, (parseInt(storedAttempts, 10) + 1).toString());
        this.attempts = (parseInt(storedAttempts, 10) + 1);
      } else {
        localStorage.setItem(key, 1);
        this.attempts = 1;
      }
    },
  },
};
</script>

<style lang="scss">
$fontSemibold: "OpenSans-Semibold";
$fontBold: "OpenSans-Bold";

#header {
  width: 100%;
  padding: 0;
  float: left;
  height: 100vh;
}

.parallaxbg {
  background-image: url(~@common/asset/images/login_bg.jpg);
  // margin: -120px -20px -20px -20px !important;
  width: 100%;
  margin: 0 auto;
  background-position: center center;
  background-size: cover;
  background-attachment: fixed;
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
  overflow: hidden;
}

.login-btn {
  background-color: #077D8A !important;
  border: 1px solid #077D8A !important;
  border-radius: 4px !important;
}

.section-overly {
  min-height: 100vh;

  .no-padding {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .dspl_inline {
    display: inline;
  }

  .dspl_inlineblock {
    display: inline-block;
  }

  .inputtitle {
    width: 100%;
    margin-bottom: 25px;
    font-family: $fontSemibold;
    font-size: 1.4rem;
    color: #005399;
    text-align: left;

    &.text-md {
      font-size: 1.3rem !important;
    }
  }

  .login-info {
    margin-bottom: 20px;
    font-size: 1.2rem;
    line-height: 20px;
    color: #5a6277;
    text-align: left;
  }

  .outer-text {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
  }

  .middle-text {
    display: table;
    width: 100%;
    height: 100%;
  }

  .inner-text {
    display: table-cell;
    vertical-align: middle;
  }

  form {
    input {
      width: 100%;
      border: 0;
      border-bottom: 1px solid #9B9B9C;
      padding: 12px 0 9px;
      font-family: $fontSemibold;
      font-size: 12px;
      color: #404040;
      height: 34px;

      &:focus {
        outline: none;
        border-bottom: 1px solid #003F91;
      }
    }

    .input-group {
      position: relative;
      width: 100%;
      margin: 10px 0 20px;

      label {
        content: attr(data-placeholder);
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        -webkit-transform: translate(0%, -50%);
        transform: translate(0%, -50%);
        -webkit-transition: all 0.3s ease-in-out;
        transition: all 0.3s ease-in-out;
        background-color: rgba(255, 255, 255, 0);
        color: #404040;
        font-size: 10px;
        font-weight: normal;
        line-height: 10px;
        text-transform: uppercase;

        input[type="text"],
        input[type="password"] {
          border-bottom: 1px solid #9999a3;
        }

        input[type="text"]:focus,
        input[type="text"]:valid,
        input[type="password"]:focus,
        input[type="password"]:valid {
          border-bottom: 1px solid #9b9b9c;
        }

        input:focus~label,
        input:valid~label {
          top: -1px;
          color: #404040;
          font-size: 10px;
          font-weight: normal;
          line-height: 10px;
          text-transform: uppercase;
        }
      }
    }
  }

  .modal-wrap {
    max-width: 1000px !important;
    margin: 0 auto;
    border-radius: 10px;
    box-shadow: 3px 3px 10px 0 #01314f;
    -webkit-transition: -webkit-transform 300ms ease-in-out;
    transition: -webkit-transform 300ms ease-in-out;
    transition: transform 300ms ease-in-out;
    transition: transform 300ms ease-in-out, -webkit-transform 300ms ease-in-out;

    .modal-bodies {
      position: relative;
      -webkit-perspective: 1000px;
      perspective: 1000px;
    }

    .modal-body {
      margin: 0;
    }
  }

  .login-page form {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .login-wrap {
    box-shadow: 5px 0 10px 1px rgba(0, 0, 0, 0.1);
    background: #fff;
    border-radius: 4px 0px 0px 4px !important;
    height: 528px;

    .login-header {
      padding: 30px 20px 20px 30px;
      text-align: left;
    }

    .login-form {
      padding: 45px 50px;

      &.reset {
        padding-right: 15px;
      }
    }

    .border-line {
      border: 2px solid #008aff;
      float: left;
      width: 47px;
      margin: 0 30px;
    }
  }

  .footer-section {
    margin: 10px 0;

    .forgot-pswd h4 {
      float: left;
      margin: 0;
      color: #008aff;
      font-size: 1rem;
      line-height: 26px;
      cursor: pointer;
    }
  }

  .button-style {
    text-align: right;

    .primary-btn {
      cursor: pointer;
      background-color: #008aff;
      color: #fff;
      border: 1px solid #008aff;
      border-radius: 2px;
      padding: 7px 10px;
      text-transform: uppercase;
      font-size: 1rem;
      font-weight: normal;
      white-space: nowrap;
      outline: none;
    }
  }

  .conditions {
    padding: 0 50px 30px;
    vertical-align: bottom;
    position: relative;

    h5 {
      color: #008aff;
      font-family: $fontSemibold;
      font-size: 10px;
      text-align: left;
    }

    p {
      color: #929292;
      font-size: 9px;
      letter-spacing: 0.23px;
      text-align: left;
    }
  }

  .error {
    display: block;
    color: #e8655d;
    font-size: 15px;
    margin: 10px;
  }
}

.msglength {
  margin-top: 10px;

  &-text {
    font-size: 10px;
    color: #5a6277;
    float: left;
  }

  &-character {
    font-size: 10px;
    color: #5a6277;
    float: right;
  }
}

.radius-right {
  line-height: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.msg-content {
  color: #5a6277;
  font-size: 12px;
  text-align: left;
  line-height: 18px;
}

.floatleft {
  float: left !important;
}

.floatright {
  float: right !important;
}

.msgerror {
  color: #d12424;
}

.button-style button:disabled {
  opacity: 0.2;
}

.mt-40 {
  margin-top: 40px;
}

.fw-600 {
  font-weight: 600;
}

.captcha-wrapper {
  height: 100%;
  position: fixed;
  top: 15%;
  transform: translateX(-50%);

  .captcha-vertical-center {
    width: 345px;
    padding: 20px;
    margin-left: -172px;
    position: absolute;
    top: 48%;
    left: 0;
    border-radius: 4px;
    box-shadow: 0px 14px 28px rgba(0, 0, 0, 0.06);
    transform: translateY(-48%);
  }
}
</style>

